import axios from 'axios';
const url =  Config.serviceUrl;
axios.defaults.headers.post['Content-Type'] = 'application/json';
import { matchUrl, setCookie } from '../utils/utils'
import { message } from 'antd';

function httpChecked(res){
    if (res.data.code === 200) {
        return res.data.data != undefined ? res.data.data : []
    } else if(res.data.code === 40002) {
        const loginUrl = matchUrl('index')
        window.location.href = loginUrl; 
    } else if(res.data.code === 500 || res.data.code === 504){
        message.error(res.data.msg);
    } else if(res.data.code === 99999){
        message.error('服务器错误');
    } else {
        // TODO res 不存在data数据 只有msg code
        res.data.msg && message.error(res.data.msg);
        return;
    }
}


/**
 * 登陆
 * @param {String} userName 
 * @param {String} password 
 */
export async function app_login(userName, password) {
    return axios.post(url + "/uc/auth/devLogin", {
        'username': userName,
        'password': password
    })
        .then(res => {
            if (res.data && res.data.code === 200) {
                return res
            } else if(res.data) {
                message.error(res.data.msg);
            }
        }, function (err) {
            alert('操作失败');
        });
}

//退出登录
export async function app_logout(access_token) {
    return axios.get(url + "/uc/auth/logout?access_token=" + access_token)
        .then(res => {
            // alert(res.data.msg);
        }, function (err) {
            alert('操作失败');
        })
}


//注册
export async function app_register(userName, userPassword, phoneNumber, checkNum) {
    return axios.post(url + "/uc/user/register", {
        "name": " ",
        "loginName": userName,
        "password": userPassword,
        "email": " ",
        "mobile": phoneNumber,
        "id": " ",
        checkNum
    })
        .then(res => {
            return res;
        }, function (err) {
            alert('操作失败');
        });
}

/**
 * 获取注册验证码
 * @param {String} userName 
 * @param {Number} phoneNumber 
 */
export async function app_getCaptcha(userName, phoneNumber) {
    return axios.get(url + `/uc/sms/sendCheckNum?phone=${phoneNumber}&username=${userName}`)
        .then(res => {
            if(res.data) {
                return res;
            } 
        }, function(err){
            return {data: {code: '', status: 'fail', msg: '服务器连接失败'}}
        })
}

/**
 * 获取找回密码验证码
 * @param {String} loginName 
 * @param {String} mobile 
 */
export async function app_getCaptcha_retrieve(loginName, mobile) {
    return axios.post(url + `/uc/user/checkSetNewPassword`, {
        loginName,
        mobile
    }).then(res => {
        if(res.data) return res
    }, function(err) {
        alert('操作失败');
    })
}

/**
 * 重置密码
 * @param {String} loginName 
 * @param {String} mobile 
 * @param {String} checkNum 
 * @param {String} password 
 */
export async function app_set_new_password(loginName, mobile, checkNum, password) {
    return axios.post(url + `/uc/user/setNewPassword`, {
        loginName,
        mobile,
        checkNum,
        password
    }).then(res => {
        if(res.data) return res
    }).catch(err => {
        alert(err)
        alert('操作失败');
    })
}

/**
 * 用户查询工程
 * @param {Number} pageNo 
 * @param {Number} pageSize 
 * @param {String} access_token 
 * @param {String} type 
 * @param {Object} sort 
 * @param {String} name 
 * @param {String} appId 
 */
export async function queryProjectList(pageNo, pageSize, access_token, type, sort, name, appId) {
    return axios.post(url + "/bp/project/postForUserProjectList?pageNo=" + pageNo + "&pageSize=" + pageSize + "&access_token=" + access_token,
        {
            "type":type, sort, "name":name,"appId": appId
        })
        .then((res) => {
            return httpChecked(res)
        }, function (err) {
            alert('操作失败');
        })
}

//用户修改工程
export async function modifyProject(data,access_token) {
    return axios.post(url + "/bp/project/setProjectName?access_token=" + access_token, data)
        .then((res) => {
            return httpChecked(res)
        }, function (err) {
            alert('操作失败');
        })
}


//用户删除工程
export async function deleteProject(id,access_token) {
    return axios.post(url + "/bp/project/remove?access_token=" + access_token + "&id=" + id)
        .then((res) => {
            return httpChecked(res)
        }, function (err) {
            alert('操作失败');
        })
}

//builderAPP删除
export async function deleteBuilderAPP(id,access_token) {
    return axios.post(url + "/build/mobile/delete?access_token=" + access_token + "&id=" + id)
        .then((res) => {
            return httpChecked(res)
        }, function (err) {
            alert('操作失败');
        })
}

//builderAPP修改
export async function modifyBuilderAPP(data,access_token) {
    return axios.post(url + "/build/mobile/update?access_token=" + access_token, data)
        .then((res) => {
            return httpChecked(res)
        }, function (err) {
            alert('操作失败');
        })
}

//builderAPP添加
export async function addBuilderApp(access_token,data) {
    return axios.post(url + "/build/mobile/save?access_token=" + access_token, data)
        .then((res) => {
            if (res.data.code === 200) {
                return res.data;
            } else {
                message.error(res.data.msg);
            }
        }, function (err) {
            alert('操作失败');
        })
}

/**
 * builderAPP查询
 * @param {Number} pageNo 
 * @param {Number} pageSize 
 * @param {String} access_token 
 * @param {Object} sort 
 * @param {String} name 
 * @param {String} appId 
 */
export async function builderAppQuery(pageNo, pageSize, access_token, sort, name, appId) {
    return axios.post(url + "/build/mobile/page?pageNo=" + pageNo + "&pageSize=" + pageSize + "&access_token=" + access_token,
        {
            "name":name,"appId": appId, sort
        })
        .then((res) => {
            return httpChecked(res)
        }, function (err) {
            alert('操作失败');
        })
}

/**
 * 查询Builer
 * @param {String} access_token 
 */
export async function queryBuilderApp(access_token) {
    return axios.get(`${url}/uc/app/getAllBuild?access_token=${access_token}`)
        .then(res => {
            return httpChecked(res)
        }, function(err) {
            alert('操作失败');
        })
}



//重置appsecret
export async function resetAppSecret (access_token,appId,appSecret) {
    return axios.post(url + "/uc/app/resetAppSecret?access_token=" + access_token, {"appId":appId, "appSecret":appSecret})
        .then((res) => {
            return httpChecked(res)
        }, function (err) {
            alert('操作失败');
        })
}

//修改用户信息
export async function modifyAndResetPassword (access_token,data) {
    return axios.post(url + "/uc/user/modifyAndResetPassword?access_token=" + access_token, data)
        .then((res) => {
            return res;
        }, function (err) {
            alert('操作失败');
        })
}

//修改应用名称
export async function modifyAppName (access_token,data) {
    return axios.post(url + "/uc/app/save?access_token=" + access_token, data)
        .then((res) => {
            return res;
        }, function (err) {
            alert('操作失败');
        })
}

/**
 * 查询所有应用
 * @param {String} access_token 
 */
export async function getAllApp(access_token) {
    return axios.get(url + "/uc/app/getAll?access_token=" + access_token).then(res=>{
        return httpChecked(res)
    }, function (err) {
        alert('操作失败');
    })
}


//查询所用app信息
export async function getAllUserInfo(access_token) {
    return axios.get(url + "/uc/user/getDetail?access_token=" + access_token).then(res=>{
        return httpChecked(res)
    }, function (err) {
        alert('操作失败');
    })
}


//查询应用管理卡片
export async function getUserAppProjectInfoList(access_token) {
    return axios.get(url + "/bp/project/getUserAppProjectInfoList?access_token=" + access_token).then(res=>{
        return httpChecked(res)
    }, function (err) {
        alert('操作失败');
    })
}


//查询字典值
export async function queryDict(access_token) {
    return axios.get(url + '/uc/dict/getAllDictMap?access_token=' + access_token)
        .then((res) => {
            return httpChecked(res)
        }, function (err) {
            alert('操作失败');
        })
}

/**
 * 绑定企业账号
 * @param {String} access_token 
 * @param {Object} data 
 */
export async function app_bind_count(access_token, data) {
    return axios.post(`${url}/build/app/bindEnterprise?access_token=${access_token}`, data)
        .then(res => {
            if(res.data) {
                return res
            }
        }, function(err) {
            alert('操作失败');
        })
}

/**
 * 登录用户的权限验证
 * @param {String} access_token 
 */
export async function checkIsDeveloper(access_token) {
    return axios.post(`${url}/uc/user/isDeveloper`, {}, {headers: {access_token}})
        .then(res => {
            if (res) return res;
        }, function(err) {
            alert('操作失败');
            return;
        })
}

/**
 * 根据工程id查询转换个数以及最靠前的位置
 * @param {String} access_token 
 */
export async function getPdsStats(access_token, data) {
    return axios.post(`${url}/rf/pds/trans/bim/stats`, data, {headers: {access_token}})
        .then(res => {
            if (res) return httpChecked(res);
        }, function(err) {
            alert('操作失败');
            return;
        })
}

/**
 * 上传tif文件
 * @param access_token
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function tifUpload(access_token, data,onUploadProgress,callback){
    let type = 'multipart/form-data;charset=UTF-8';
    let config = {
        processData: false,
        // maxContentLength:10, 无效
        //添加请求头
        headers: { 'Content-Type': type,"access_token":access_token , 'X-Requested-With': 'XMLHttpRequest'},
        //添加上传进度监听事件
        // onUploadProgress: onUploadProgress,
        transformRequest: [function (data, headers) {
            if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
                // 把一个参数对象格式化为一个字符串
                return qs.stringify(data)
            } else if (headers['Content-Type'].indexOf('multipart/form-data') >=0 ) {
                return data
            } else {
                headers['Content-Type'] = 'application/json'
            }
            return JSON.stringify(data)
        }]
    };
    return axios.post(`${url}/gis/layer/upload`, data, config)
        .then(res => {
            callback()
            if (res) return httpChecked(res);
        }, function(err) {
            alert('操作失败');
            callback()
            return;
        }).catch( (e) => {callback()})
}

export async function queryLayerList(pageNo, pageSize, access_token) {
    return axios.get(url + "/gis/layer/page?pageNo=" + pageNo + "&pageSize=" + pageSize + "&access_token=" + access_token)
        .then((res) => {
            return httpChecked(res)
        }, function (err) {
            alert('操作失败');
        })
}

export async function deleteLayer(id,access_token) {
    return axios.delete(url + "/gis/layer/" +id+ "?access_token=" + access_token)
        .then((res) => {
            return httpChecked(res)
        }, function (err) {
            alert('操作失败');
        })
}

export async function verifyName(name,access_token) {
    return  axios.get(url + "/gis/layer/verify/name?access_token=" + access_token+"&name="+name)
        .then((res) => {
            return httpChecked(res)
        }, function (err) {
            alert('操作失败');
        })
}




